// Verteilt auf die Seiten. Kein Router-Paket: Die Anwendung hat gut ein
// Dutzend Seiten und keine verschachtelten Layouts — ein switch über die
// Sicht ist kürzer als die Konfiguration einer Bibliothek.

import { Anmeldung } from "./komponenten/Anmeldung.tsx";
import { Huelle } from "./komponenten/Huelle.tsx";
import {
  Dashboard, ObjekteSeite, ObjektSeite, EinheitSeite, EinheitenSeite,
  MaengelSeite, InventarSeite, VorlageSeite, SanierungSeite,
  MieterSeite, VertraegeSeite, KontoSeite, BaldSeite,
} from "./seiten/Seiten.tsx";
import { AufgabenSeite, DokumenteSeite, KommunikationSeite } from "./seiten/Sonstiges.tsx";
import { FinanzenSeite } from "./seiten/Finanzen.tsx";
import { useZustand } from "./zustand.tsx";

function Inhalt() {
  const { sicht, bestand, bestandFehler, neuLaden, zeigeMeldung } = useZustand();

  // Ohne diesen Zweig stünde die Anwendung bei einem Ladefehler dauerhaft
  // auf „wird geladen“ — ohne Erklärung und ohne Ausweg.
  if (!bestand) {
    return bestandFehler ? (
      <div className="empty" style={{ marginTop: 40 }}>
        <strong>Der Bestand ließ sich nicht laden.</strong>
        {bestandFehler}
        <br /><br />
        <button className="btn btn-primary" onClick={() => {
          void neuLaden().catch(() => zeigeMeldung("Es klappt weiterhin nicht.", true));
        }}>Erneut versuchen</button>
      </div>
    ) : (
      <div className="laden">Bestand wird geladen …</div>
    );
  }

  switch (sicht.seite) {
    case "dashboard": return <Dashboard />;
    case "objekte": return <ObjekteSeite />;
    case "objekt": return <ObjektSeite objektId={sicht.objektId} reiter={sicht.reiter} />;
    case "einheiten": return <EinheitenSeite />;
    case "einheit":
      return <EinheitSeite objektId={sicht.objektId} einheitId={sicht.einheitId} reiter={sicht.reiter} />;
    case "maengel": return <MaengelSeite />;
    case "inventar": return <InventarSeite />;
    case "vorlage": return <VorlageSeite />;
    case "sanierung": return <SanierungSeite />;
    case "mieter": return <MieterSeite />;
    case "vertraege": return <VertraegeSeite />;
    case "aufgaben": return <AufgabenSeite />;
    case "dokumente": return <DokumenteSeite />;
    case "kommunikation": return <KommunikationSeite />;
    case "finanzen": return <FinanzenSeite bereich={sicht.bereich} />;
    case "konto": return <KontoSeite />;
    case "bald": return <BaldSeite thema={sicht.thema} />;
  }
}

export function App() {
  const { benutzer, laedt } = useZustand();

  // Solange offen ist, ob eine Sitzung besteht, weder Anmeldung noch Inhalt
  // zeigen — sonst blitzt bei jedem Neuladen kurz der Anmeldebildschirm auf.
  if (laedt) return <div className="laden">Einen Moment …</div>;
  if (!benutzer) return <Anmeldung />;

  return <Huelle><Inhalt /></Huelle>;
}
